import {
  BookOpen01Icon,
  CalendarDateIcon,
  InfoCircleIcon,
  MessageChatCircleIcon,
  Trophy01Icon,
  Users01Icon,
} from '@gohighlevel/ghl-icons/24/outline'

export enum TabName {
  DISCUSSION = 'DISCUSSION',
  LEARNING = 'LEARNING',
  EVENTS = 'EVENTS',
  LEADERBOARD = 'LEADERBOARD',
  MEMBERS = 'MEMBERS',
  ABOUT = 'ABOUT',
}

export interface TabConfiguration {
  name: TabName
  isVisible: boolean
}

export const DEFAULT_TAB_CONFIGURATION: TabConfiguration[] = [
  { name: TabName.DISCUSSION, isVisible: true },
  { name: TabName.LEARNING, isVisible: true },
  { name: TabName.EVENTS, isVisible: true },
  { name: TabName.LEADERBOARD, isVisible: true },
  { name: TabName.MEMBERS, isVisible: true },
  { name: TabName.ABOUT, isVisible: true },
]

// Map TabConfiguration names to navigation item names
export const TAB_NAME_TO_NAV_NAME_MAP: Record<TabName, string> = {
  [TabName.DISCUSSION]: 'tabSwitcher.discussion',
  [TabName.LEARNING]: 'tabSwitcher.learning',
  [TabName.EVENTS]: 'common.events',
  [TabName.LEADERBOARD]: 'tabSwitcher.leaderboard',
  [TabName.MEMBERS]: 'tabSwitcher.members',
  [TabName.ABOUT]: 'common.about',
}

// Tab metadata - single source of truth for all tab information
interface TabMetadata {
  labelKey: string
  descriptionKey: string
  isMandatory: boolean
  icon: unknown
}

export const TAB_METADATA: Record<TabName, TabMetadata> = {
  [TabName.DISCUSSION]: {
    labelKey: 'tabSwitcher.discussion',
    descriptionKey: 'groupInfo.tabConfiguration.discussionDescription',
    isMandatory: true,
    icon: MessageChatCircleIcon,
  },
  [TabName.LEARNING]: {
    labelKey: 'tabSwitcher.learning',
    descriptionKey: 'groupInfo.tabConfiguration.learningDescription',
    isMandatory: false,
    icon: BookOpen01Icon,
  },
  [TabName.EVENTS]: {
    labelKey: 'common.events',
    descriptionKey: 'groupInfo.tabConfiguration.eventsDescription',
    isMandatory: false,
    icon: CalendarDateIcon,
  },
  [TabName.LEADERBOARD]: {
    labelKey: 'tabSwitcher.leaderboard',
    descriptionKey: 'groupInfo.tabConfiguration.leaderboardDescription',
    isMandatory: false,
    icon: Trophy01Icon,
  },
  [TabName.MEMBERS]: {
    labelKey: 'tabSwitcher.members',
    descriptionKey: 'groupInfo.tabConfiguration.membersDescription',
    isMandatory: false,
    icon: Users01Icon,
  },
  [TabName.ABOUT]: {
    labelKey: 'common.about',
    descriptionKey: 'groupInfo.tabConfiguration.aboutDescription',
    isMandatory: true,
    icon: InfoCircleIcon,
  },
}
